export default __webpack_public_path__ + "static/media/functions_openapi.b5ab3f49.yaml";